import { CheckCircle2, AlertTriangle, Circle } from "lucide-react";

const CONFIG = {
  on_track: { label: "On track", icon: Circle, className: "pl-chip-blue" },
  overdue: { label: "Overdue", icon: AlertTriangle, className: "pl-chip-red" },
  completed: { label: "Completed", icon: CheckCircle2, className: "pl-chip-blue-solid" },
};

export default function StatusChip({ status }) {
  const cfg = CONFIG[status] || CONFIG.on_track;
  const Icon = cfg.icon;
  return (
    <span className={`pl-chip ${cfg.className}`}>
      <Icon size={11} /> {cfg.label}
    </span>
  );
}